import { Navigate, Outlet, Route } from "react-router-dom";

import { App } from "@/App";
import { PartnerLoginRedirect } from "@/apps/partner/router/PartnerLoginRedirect";
import { PARTNER_ADD_DEVICE_BASE } from "@/apps/partner/utils/partnerAddDevice.constants";
import { AddDevice } from "@/apps/partner/views/AddDevice/AddDevice";
import { PartnerPersonalDetailsStep } from "@/apps/partner/views/AddDevice/steps/PartnerPersonalDetailsStep";
import { PartnerQuantityStep } from "@/apps/partner/views/AddDevice/steps/PartnerQuantityStep";
import { PartnerRateStep } from "@/apps/partner/views/AddDevice/steps/PartnerRateStep";
import { PartnerSimTypeStep } from "@/apps/partner/views/AddDevice/steps/PartnerSimTypeStep";
import PartnerDashboard from "@/apps/partner/views/Dashboard/PartnerDashboard";
import { WelcomePartnerPortal } from "@/apps/partner/views/Login/WelcomePartnerPortal";
import { PartnerPortal } from "@/apps/partner/views/PartnerPortal/PartnerPortal";
import Success from "@/apps/partner/views/Success/Success";
import { WelcomeLoadingSpinner } from "@/components/Welcome/WelcomeLoadingSpinner";
import { ProtectedRoute } from "@/router/ProtectedRoute";

export const partnerRoutes = [
  <Route
    key="partnerBaseRoute"
    path="/partner"
    element={
      <ProtectedRoute user="partner">
        <App />
      </ProtectedRoute>
    }
  >
    <Route index element={<Navigate to="/partner/cockpit" replace />} />
    <Route element={<PartnerDashboard />}>
      <Route path="cockpit" element={<PartnerPortal />} />
      <Route path="add-sim" element={<AddDevice />}>
        <Route
          index
          element={
            <Navigate to={`${PARTNER_ADD_DEVICE_BASE}/1/sim-type`} replace />
          }
        />
        <Route path="1/sim-type" element={<PartnerSimTypeStep />} />
        <Route path="2/rate-selection" element={<PartnerRateStep />} />
        <Route path="3/quantity" element={<PartnerQuantityStep />} />
        <Route
          path="4/personal-details"
          element={<PartnerPersonalDetailsStep />}
        />
      </Route>
      <Route path="add-sim/success" element={<Success />} />
    </Route>
  </Route>,

  <Route
    key="partner-welcome-base"
    element={
      <PartnerLoginRedirect>
        <Outlet />
      </PartnerLoginRedirect>
    }
  >
    <Route
      key="welcome-partner"
      path="/welcome-partner"
      element={<WelcomePartnerPortal />}
    />
    <Route
      key="welcome-partner-loading"
      path="/welcome-partner/loading"
      element={<WelcomeLoadingSpinner />}
    />
  </Route>,
];
